module.exports = __webpack_public_path__ + "f6f4922daa3921288923392a35741154.woff2";